export class TagManagerConstants {
  public static readonly TagManagerConfigName = 'TagMan';
  public static readonly AvailabilityFlag = 'AvailabilityFlag';
  public static readonly GoogleClientId = 'GoogleClientId';
  public static readonly GoogleEventName = 'GoogleEventName';
  public static readonly PageNameParam = 'PageNameParam';
  public static readonly PageNameParamValuePartial = 'PageNameParamValuePartial';
  public static readonly ProductNameParam = 'ProductNameParam';
  public static readonly ProductNameParamValue = 'ProductNameParamValue';
  public static readonly UserLoginStatusParam = 'UserLoginStatusParam';
  public static readonly ProductVariationParam = 'ProductVariationParam';
  public static readonly ProductVariationParamValueResidental = 'ProductVariationParamValueResidental';
  public static readonly ProductVariationParamValueBtl = 'ProductVariationParamValueBtl';
  public static readonly FormNameParam = 'FormNameParam';
  public static readonly QuoteIdParam = 'QuoteIdParam';
  public static readonly TransactionIdParam = 'TransactionIdParam';
  public static readonly AccountIdParam = 'AccountIdParam';
  public static readonly AppStageParam = 'AppStageParam';
  public static readonly AppStageParamValueAip = 'AppStageParamValueAip';
  public static readonly AppStageParamValueApp = 'AppStageParamValueApp';
  public static readonly DecisionParam = 'DecisionParam';
  public static readonly DecisionParamValueAccept = 'DecisionParamValueAccept';
  public static readonly DecisionParamValueDecline = 'DecisionParamValueDecline';
  public static readonly DecisionParamValueRefer = 'DecisionParamValueRefer';

  public static readonly GoogleAnalyticsConfigName = 'GoogleAnalytics';
  public static readonly GoogleAnalyticsConfigIdCode = 'GoogleTagManClientId';

  public static readonly CaseNumberParamName = 'caseNumber';
  public static readonly MortgageClassParamName = 'mortgageClass';
  public static readonly AccountTypeParamName = 'accountType';
  public static readonly HeaderSwitchEligibilityParamName = 'headerSwitchEligibility';
  public static readonly TransactionInProgressParamName = 'transactionInProgress';
  public static readonly RomeUserIdParamName = 'romeUserId';
  public static readonly SwitchCaseIdParamName = 'switchCaseId';
  public static readonly SwitchTaskIdParamName = 'switchTaskId';
  public static readonly ProductSelectedParamName = 'productSelected';
  public static readonly TermExtensionParamName = 'termExtension';
  public static readonly TermReductionParamName = 'termReduction';

  public static readonly EventParamName = 'event';
  public static readonly EventSwitchCaseCreated = 'switchCaseCreated';
  public static readonly EventCustomerAccountLoaded = 'customerAccountLoaded';

  public static readonly NoClientId = ' ';
}
